import React from "react";
import { imageShowData } from "../GiftImage";

export default function RecordsDialog(props) {
  const { open, setOpen, historyRecord } = props;

  const handleClose = () => {
    setOpen(false);
  };

  function dateFunction(dateString) {
    if (!dateString) return "-";
    const dateObject = new Date(dateString);
    const timeString = dateObject.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    const dateSting = dateObject.toLocaleDateString([], {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
    return { date: dateSting, time: timeString };
  }

  if (!open) return null;

  return (
    <div className="bottom-sheet-overlay" onClick={handleClose}>
      <div className="bottom-sheet-paper records-sheet" onClick={(e) => e.stopPropagation()}>

        {/* ── Header ── */}
        <div className="history-modal-header">
          <div style={{ width: "36px" }} />
          <h2 className="history-modal-title">Records</h2>
          <button className="history-modal-close" onClick={handleClose}>
            ✕
          </button>
        </div>

        {/* ── Column Header Row ── */}
        <div className="records-col-header">
          <div className="records-col records-col-main">Win or Loss</div>
          <div className="records-col">Coins</div>
          <div className="records-col">Selected</div>
          <div className="records-col">Result</div>
        </div>

        {/* ── Scrollable Content ── */}
        <div className="records-scroll-body">
          {historyRecord && historyRecord.length > 0 ? (
            historyRecord.map((item, index) => {
              const isWin = item?.isWinner === true;
              const dt = item?.createdAt ? dateFunction(item.createdAt) : null;

              return (
                <div key={index} className="records-row">
                  {/* Win / Loss + Date */}
                  <div className="records-cell records-cell-main">
                    <span className={`records-winloss ${isWin ? "records-win" : "records-loss"}`}>
                      {isWin ? "Win" : "Loss"}
                      {isWin && item?.winnerNumberTimes ? (
                        <span className="records-times"> ({item.winnerNumberTimes}x)</span>
                      ) : null}
                    </span>
                    {dt && (
                      <span className="records-datetime">
                        {dt.date}
                        <span className="records-time-dot"> • </span>
                        {dt.time}
                      </span>
                    )}
                  </div>

                  {/* Coins */}
                  <div className="records-cell">
                    <span className="records-coin-val">{item?.Bit}</span>
                  </div>

                  {/* Selected Image */}
                  <div className="records-cell">
                    {item?.selectedFrame != null && imageShowData[item.selectedFrame - 1] ? (
                      <img
                        src={imageShowData[item.selectedFrame - 1]}
                        alt="Selected"
                        className="records-fruit-img"
                      />
                    ) : (
                      <span className="records-empty-img">—</span>
                    )}
                  </div>

                  {/* Result Image */}
                  <div className="records-cell">
                    {item?.winnerNumber != null && imageShowData[item.winnerNumber - 1] ? (
                      <img
                        src={imageShowData[item.winnerNumber - 1]}
                        alt="Result"
                        className="records-fruit-img"
                      />
                    ) : (
                      <span className="records-empty-img">—</span>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <div className="records-empty-state">
              <span>No Records Found</span>
            </div>
          )}
        </div>

      </div>
    </div>
  );
}
